import {
  Component,
  computed,
  effect,
  inject,
  signal,
  untracked,
  WritableSignal,
} from '@angular/core';
import {
  ClientUrlBuilder,
  ClientUrls,
  ProfileUrls,
} from '../../../routing/client-urls';
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';

import { ImageSources } from '../../../constants/image-sources';
import { SvgIconComponent } from 'angular-svg-icon';
import { svgIconKeys } from '../../../constants/svg-icon-keys';
import { LayoutStore } from '../../store/layout/layout.store';
import { AsyncPipe, CommonModule, NgClass } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { AuthService } from '@auth0/auth0-angular';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AuthStore } from '../../store/authentication/auth.store';
import {
  LocalStorageKeys,
  LocalStorageService,
} from '../../services/local-storage.service';
import { ShowImpersonationComponent } from '../show-impersonation/show-impersonation.component';
import { UserStatus } from '../../store/authentication/types';
import { UserDeactivatedPopup } from '../../../client/popups/user-deactived/user-deactivated.popup';
import { isSameDay, startOfDay } from 'date-fns';

import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FormsModule } from '@angular/forms';
import { AccountContract } from '../../../client/store/accounts/types';
import { AccountsStore } from '../../../client/store/accounts/accounts.store';
import { TasksStore } from '../../../client/store/tasks/tasks.store';
import { SegmentsStore } from '../../../client/store/segments/segments.store';
import { ButtonModule } from 'primeng/button';
import { AccountsSearchComponent } from '../../../client/components/accounts-search/accounts-search.component';
import { PlanVisitPopup } from '../../../client/popups/plan-visit/plan-visit.popup';
import { LoopsStore } from '../../../client/store/loops/loops.store';
import { ToastService } from '../../services/toast.service';
import { ApiError } from '../../services/http-gateway.service';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import {
  getClusterId,
  hasOrgPermission,
  hasPermission,
  Permission,
  Role,
} from '../../store/authentication/types';
import { getToday } from '../../../client/utils/get-today';
@Component({
  selector: 'blindspot-page-wrapper',
  styleUrls: ['./page-wrapper.component.scss'],
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    SvgIconComponent,
    NgClass,
    ToastModule,
    AsyncPipe,
    ProgressSpinnerModule,
    SvgIconComponent,
    ShowImpersonationComponent,
    UserDeactivatedPopup,
    IconFieldModule,
    InputIconModule,
    AutoCompleteModule,
    FormsModule,
    ButtonModule,
    AccountsSearchComponent,
    PlanVisitPopup,
    TranslocoModule,
    MenuModule,
    CommonModule,
  ],
  template: `
    <blindspot-plan-visit-popup
      [(visible)]="planVisitPopupVisible"
      [loading]="loopsStore.isLoading('createWarmVisit')"
      (planVisit)="onPlanVisit($event.account, $event.date, $event.time)"
    />
    @if (deactivatedUserVisible()) {
      <blindspot-user-deactivated-popup
        [visible]="deactivatedUserVisible()"
        (logout)="logout()"
      />
    } @else {
      <div class="container" *transloco="let t">
        @if (
          layoutStore.showNavigation() &&
          !(
            (auth.isLoading$ | async) ||
            !(auth.isAuthenticated$ | async) ||
            authStore.isLoading('getLoggedInUser')
          )
        ) {
          <div class="header">
            <div class="nav-search">
              <nav>
                <img class="logo" alt="Logo" [src]="ImageSources.logoSmall" />
                <ul>
                  <li
                    [ngClass]="{
                      active:
                        (router.isActive(
                          ClientUrlBuilder.build(ClientUrls.Planning),
                          false
                        ) &&
                          !router.isActive(
                            ClientUrlBuilder.build(ClientUrls.CreateLoop),
                            false
                          )) ||
                        (router.isActive(
                          ClientUrlBuilder.build(ClientUrls.CreateLoop),
                          false
                        ) &&
                          !isSameDay(getToday(), date())),
                    }"
                    [routerLink]="ClientUrlBuilder.build(ClientUrls.Planning)"
                    [queryParams]="{ date: date() }"
                  >
                    <p>{{ 'navigation.planning' | transloco }}</p>
                  </li>
                  @if (canSeeToday()) {
                    <li
                      routerLinkActive="active"
                      [routerLink]="
                        ClientUrlBuilder.build(ClientUrls.CreateLoop)
                      "
                      [queryParams]="{ date: getToday().toISOString() }"
                    >
                      <p>{{ 'navigation.today' | transloco }}</p>
                    </li>
                  }
                  @if (canReadAccounts()) {
                    <li
                      routerLinkActive="active"
                      [routerLink]="ClientUrlBuilder.build(ClientUrls.Accounts)"
                    >
                      <p>{{ 'navigation.accounts' | transloco }}</p>
                    </li>
                  }
                  @if (canSeeTasks()) {
                    <li
                      routerLinkActive="active"
                      [routerLink]="ClientUrlBuilder.build(ClientUrls.Tasks)"
                    >
                      <p>{{ 'navigation.tasks' | transloco }}</p>
                      @if (myOpenTaskCount() > 0) {
                        <span class="nav-badge">{{ myOpenTaskCount() }}</span>
                      }
                    </li>
                  }
                  @if (canSeeActivities()) {
                    <li
                      routerLinkActive="active"
                      [routerLink]="
                        ClientUrlBuilder.build(ClientUrls.Activities)
                      "
                    >
                      <p>{{ 'navigation.activities' | transloco }}</p>
                    </li>
                  }
                </ul>
              </nav>
              @if (canPlanVisit()) {
                <div class="search-wrapper">
                  @if (layoutStore.showBlindspotAccountSearch()) {
                    <blindspot-accounts-search
                      class="search"
                      [(currentSearch)]="currentSearch"
                      [limitToSalesRepScope]="true"
                      (selectAccount)="selectAccount($event)"
                    />
                  }
                  <div class="button">
                    <p-button
                      [label]="'buttons.planVisit' | transloco"
                      (onClick)="planVisitPopupVisible.set(true)"
                    />
                  </div>
                </div>
              }
            </div>
            <div class="profile">
              <p-menu
                appendTo="body"
                [popup]="true"
                #menu
                [model]="items"
                class="menu"
              >
                <ng-template #start>
                  <div class="profile-container">
                    <div class="p-menu-item">
                      <a
                        [routerLink]="
                          ClientUrlBuilder.build(ClientUrls.Profile)
                        "
                        class="p-menu-item-link"
                      >
                        {{ 'general.profile' | transloco }}
                      </a>
                    </div>
                    @if (canSeeSettings()) {
                      <div class="p-menu-item">
                        <a
                          [routerLink]="
                            ClientUrlBuilder.build(
                              ClientUrls.Profile + '/' + ProfileUrls.Settings
                            )
                          "
                          class="p-menu-item-link"
                        >
                          {{ 'general.settings' | transloco }}
                        </a>
                      </div>
                    }
                  </div>
                </ng-template>
                <ng-template #submenuheader let-item>
                  <span>{{ item.label | transloco }}</span>
                </ng-template>
                <ng-template #item let-item>
                  @if (item.route) {
                    <a [routerLink]="item.route" class="p-menu-item-link">
                      <span>
                        {{ item.label | transloco }}
                      </span>
                    </a>
                  } @else {
                    <a [href]="item.url" class="p-menu-item-link">
                      <span>{{ item.label | transloco }}</span>
                    </a>
                  }
                </ng-template>
                <ng-template #end>
                  <div class="logout-container">
                    <p-button
                      [label]="'general.logout' | transloco"
                      variant="outlined"
                      [style]="{ width: '100%' }"
                      icon="pi pi-sign-out"
                      (onClick)="logout()"
                    />
                  </div>
                </ng-template>
              </p-menu>
              <blindspot-show-impersonation />
              <svg-icon
                svgClass="icon"
                [src]="svgIconKeys.profile"
                (click)="menu.toggle($event)"
              ></svg-icon>
            </div>
          </div>
        }
        <div
          class="page"
          [ngClass]="{
            padding: layoutStore.pagePadding(),
            'has-nav': layoutStore.showNavigation(),
          }"
        >
          @if (
            (auth.isLoading$ | async) ||
            !(auth.isAuthenticated$ | async) ||
            authStore.isLoading('getLoggedInUser')
          ) {
            <div class="wrapper">
              <div class="flex">
                <img src="assets/logo.png" />
                <p-progress-spinner strokeWidth="4" />
              </div>
            </div>
          } @else if (
            (auth.error$ | async) || authStore.hasError('getLoggedInUser')
          ) {
            <div class="wrapper">
              <div class="flex">
                <svg-icon
                  [src]="svgIconKeys.error"
                  class="svg"
                  svgClass="icon"
                ></svg-icon>
                <div>
                  We're having trouble logging you in... Please try again later.
                </div>
              </div>
            </div>
          } @else {
            <router-outlet></router-outlet>
          }
        </div>
      </div>
    }
  `,
})
export class PageWrapperComponent {
  public router = inject(Router);
  public route = inject(ActivatedRoute);
  public layoutStore = inject(LayoutStore);
  public authStore = inject(AuthStore);
  public userClusterId = computed(() => {
    const user = this.authStore.loggedInUser();
    return user ? (getClusterId(user) ?? '') : '';
  });
  public canSeeActivities = computed(() =>
    this.authStore.hasAnyPermission([
      Permission.ACTIVITIES_READ,
      Permission.CLUSTER_ACTIVITIES_READ,
    ]),
  );

  public canSeeTasks = computed(() =>
    this.authStore.hasAnyPermission([Permission.TASKS_READ]),
  );

  public tasksStore = inject(TasksStore);
  public myOpenTaskCount = computed(() => this.tasksStore.navMyOpen() ?? 0);
  public canReadAccounts = computed(
    () =>
      this.authStore.hasPermission(Permission.ACCOUNTS_READ) &&
      this.authStore.hasRole(Role.SALES_REP),
  );
  public canPlanVisit = computed(() =>
    this.authStore.hasPermission(Permission.LOOPS_CREATE),
  );
  public canSeeToday = computed(() =>
    this.authStore.hasPermission(Permission.LOOPS_CREATE),
  );
  public canSeeSettings = computed(() =>
    this.authStore.hasPermission(Permission.LOOPS_EDIT),
  );
  public segmentsStore = inject(SegmentsStore);
  public accountsStore = inject(AccountsStore);
  public loopsStore = inject(LoopsStore);
  public auth = inject(AuthService);
  public deactivatedUserVisible = signal<boolean>(false);
  public toastService = inject(ToastService);
  public transloco = inject(TranslocoService);
  public date = signal('');
  public currentSearch = signal('');
  public searchItems: WritableSignal<AccountContract[]> = signal([]);
  public planVisitPopupVisible = signal(false);

  items: MenuItem[] | undefined;

  constructor() {
    this.route.queryParams.subscribe((params) => {
      // Check if 'date' exists in the params
      if (params['date']) {
        this.date.set(new Date(params['date']).toISOString());
      } else {
        this.date.set(''); // Clear the date if no 'date' param
      }
    });

    effect(() => {
      const user = this.authStore.loggedInUser();
      if (
        user &&
        this.canSeeTasks() &&
        this.tasksStore.navMyOpen() === undefined &&
        !this.tasksStore.isLoading('getNavOrgOpen')
      ) {
        const clusterId = this.userClusterId() || undefined;
        untracked(() =>
          this.tasksStore.getNavOrgOpen({
            salesOrganizationId: user.salesOrganizationId,
            clusterId,
          }),
        );
      }
    });

    effect(() => {
      const user = this.authStore.loggedInUser();
      if (!user) return;

      const has = (permission: Permission): boolean =>
        hasPermission(user, permission);
      // Cluster/org administration surfaces require the permission org-wide;
      // a sales rep holds the same permission cluster-scoped (see permission.guard.ts).
      const hasOrg = (permission: Permission): boolean =>
        hasOrgPermission(user, permission);

      this.items = [{ separator: true }];

      if (hasOrg(Permission.CLUSTER_ACCOUNTS_READ)) {
        this.items.push(
          {
            label: 'general.administration',
            items: [
              ...(has(Permission.CLUSTERS_CREATE)
                ? [
                    {
                      label: 'general.clusters',
                      route: ClientUrlBuilder.build(
                        ClientUrls.Profile + '/' + ProfileUrls.Clusters,
                      ),
                    },
                  ]
                : []),
              {
                label: 'general.accounts',
                route: ClientUrlBuilder.build(
                  ClientUrls.Profile + '/' + ProfileUrls.Accounts,
                ),
              },
              ...(has(Permission.SEGMENTS_UPDATE)
                ? [
                    {
                      label: 'general.segmentation',
                      route: ClientUrlBuilder.build(
                        ClientUrls.Profile + '/' + ProfileUrls.Segmentation,
                      ),
                    },
                  ]
                : []),
              ...(has(Permission.CLUSTER_SALES_REPS_READ)
                ? [
                    {
                      label: 'general.users',
                      route: ClientUrlBuilder.build(
                        ClientUrls.Profile + '/' + ProfileUrls.Users,
                      ),
                    },
                  ]
                : []),
              ...(hasOrg(Permission.CAMPAIGNS_READ)
                ? [
                    {
                      label: 'general.campaigns',
                      route: ClientUrlBuilder.build(
                        ClientUrls.Profile + '/' + ProfileUrls.Campaigns,
                      ),
                    },
                  ]
                : []),
            ],
          },
          { separator: true },
        );
      }

      if (has(Permission.USER_IMPERSONATE)) {
        this.items.push(
          {
            label: 'general.admin',
            items: [
              ...(has(Permission.SALES_ORGANIZATIONS_READ)
                ? [
                    {
                      label: 'salesOrganizations.title',
                      route: ClientUrlBuilder.build(
                        ClientUrls.Profile +
                          '/' +
                          ProfileUrls.SalesOrganizations,
                      ),
                    },
                  ]
                : []),
              {
                label: 'impersonation.title',
                route: ClientUrlBuilder.build(
                  ClientUrls.Profile + '/' + ProfileUrls.Impersonation,
                ),
              },
              ...(has(Permission.ADMIN_INVITE)
                ? [
                    {
                      label: 'general.inviteAdmin',
                      route: ClientUrlBuilder.build(
                        ClientUrls.Profile + '/' + ProfileUrls.InviteAdmin,
                      ),
                    },
                  ]
                : []),
              ...(has(Permission.MAINTENANCE_TOGGLE)
                ? [
                    {
                      label: 'maintenance.menuItem',
                      route: ClientUrlBuilder.build(ClientUrls.Maintenance),
                    },
                  ]
                : []),
            ],
          },
          { separator: true },
        );
      }
    });

    effect(() => {
      // Only fetch segments if the user is logged in
      const loggedInUser = this.authStore.loggedInUser();
      if (loggedInUser) {
        const clusterId = getClusterId(loggedInUser);
        if (clusterId) {
          this.segmentsStore.getSegments({
            salesOrganizationId: loggedInUser.salesOrganizationId,
            clusterId,
          });
        }
      }
    });

    effect(() => {
      if (
        this.loopsStore.getSuccess('createWarmVisit') &&
        this.loopsStore.loop()
      ) {
        this.planVisitPopupVisible.set(false);
        this.router.navigateByUrl(
          ClientUrlBuilder.buildDate(
            ClientUrls.CreateLoop,
            new Date(this.loopsStore.loop()!.date),
          ),
        );
        this.loopsStore.clearSuccess('createWarmVisit');
      }

      if (this.loopsStore.getError('createWarmVisit')) {
        this.toastService.errorToast(
          this.transloco.translate('toasts.error'),
          this.transloco.translate('toasts.failedToPlanVisit', {
            message: (this.loopsStore.getError('createWarmVisit') as ApiError)
              .message,
          }),
        );
        this.loopsStore.clearError('createWarmVisit');
      }
    });

    effect(() => {
      if (this.authStore.loggedInUser()?.status === UserStatus.DEACTIVATED) {
        this.deactivatedUserVisible.set(true);
      }
    });

    effect(() => {
      if (this.accountsStore.hasError('updateAccount')) {
        this.toastService.errorToast(
          this.transloco.translate('toasts.error'),
          this.transloco.translate('toasts.failedToUpdateAccount', {
            message: (this.accountsStore.getError('updateAccount') as ApiError)
              .message,
          }),
        );
        this.accountsStore.clearError('updateAccount');
      }
    });

    effect(() => {
      if (this.accountsStore.hasError('unsnoozeAccount')) {
        this.toastService.errorToast(
          this.transloco.translate('toasts.error'),
          this.transloco.translate('toasts.failedToUnsnoozeAccount', {
            message: (
              this.accountsStore.getError('unsnoozeAccount') as ApiError
            ).message,
          }),
        );
        this.accountsStore.clearError('unsnoozeAccount');
      }
    });
  }

  public logout(): void {
    this.auth.logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  }

  public stopImpersonation(): void {
    LocalStorageService.remove(LocalStorageKeys.IMPERSONATION_TOKEN);
    window.location.reload();
  }

  public selectAccount(account: AccountContract): void {
    this.currentSearch.set('');
    this.router.navigateByUrl(
      ClientUrlBuilder.build(ClientUrls.accountDetail(account.id)),
    );
  }

  public onPlanVisit(account: AccountContract, date: Date, time: Date): void {
    date.setHours(time.getHours());
    date.setMinutes(time.getMinutes());
    date.setSeconds(0);
    date.setMilliseconds(0);

    this.loopsStore.createWarmVisit({ accountId: account.id, date });
  }

  protected readonly ClientUrlBuilder = ClientUrlBuilder;
  protected readonly ClientUrls = ClientUrls;
  protected readonly ProfileUrls = ProfileUrls;
  protected readonly ImageSources = ImageSources;
  protected readonly svgIconKeys = svgIconKeys;
  protected readonly isSameDay = isSameDay;
  protected readonly startOfDay = startOfDay;
  protected readonly getToday = getToday;
}
